import apiClient from '@/api/client';

// ─── Forum aus Sicht des Betriebs ────────────────────────────────────────────
//
// Auch hier kein Stammbaum: Das Forum hat keinen. Wer hier moderiert, sieht
// Beiträge und Anzeigenamen – aber nichts aus den Stammbäumen der Beteiligten.

export interface ForumStatus {
  an: boolean;
  kategorien: number;
  themen: number;
  beitraege: number;
  offeneMeldungen: number;
}

export interface ForumKategorie {
  id: string;
  schluessel: string;
  name: string;
  beschreibung: string | null;
  reihenfolge: number;
  stillgelegt: boolean;
  themen: number;
}

export interface ForumMeldung {
  id: string;
  grund: string;
  freitext: string | null;
  gemeldetAm: string;
  erledigtAm: string | null;
  ergebnis: string | null;
  melder: string;
  beitrag: {
    id: string;
    text: string;
    vorschau: string;
    erstelltAm: string;
    ausgeblendet: boolean;
    geloescht: boolean;
    verfasserId: string | null;
    verfasser: string;
    thema: { id: string; titel: string; geschlossen: boolean };
  };
}

export interface ForumSperre {
  id: string;
  bis: string;
  grund: string;
  gesetztVon: string;
  seit: string;
  userId: string;
  email: string;
  anzeigename: string;
}

export async function ladeStatus(): Promise<ForumStatus> {
  const { data } = await apiClient.get<ForumStatus>('/forum/status');
  return data;
}

export async function schalteForum(an: boolean): Promise<{ an: boolean }> {
  const { data } = await apiClient.post<{ an: boolean }>('/forum/status', { an });
  return data;
}

export async function ladeKategorien(): Promise<ForumKategorie[]> {
  const { data } = await apiClient.get<ForumKategorie[]>('/forum/kategorien');
  return data;
}

export async function neueKategorie(felder: {
  schluessel: string;
  name: string;
  beschreibung: string;
  reihenfolge: number;
}): Promise<ForumKategorie> {
  const { data } = await apiClient.post<ForumKategorie>('/forum/kategorien', felder);
  return data;
}

export async function aendereKategorie(
  id: string,
  felder: Partial<{ name: string; beschreibung: string; reihenfolge: number; stillgelegt: boolean }>,
): Promise<ForumKategorie> {
  const { data } = await apiClient.patch<ForumKategorie>(`/forum/kategorien/${id}`, felder);
  return data;
}

export async function ladeMeldungen(alle: boolean): Promise<ForumMeldung[]> {
  const { data } = await apiClient.get<ForumMeldung[]>('/forum/meldungen', {
    params: alle ? { alle: 'true' } : {},
  });
  return data;
}

export async function erledigeMeldung(id: string, ergebnis: string): Promise<void> {
  await apiClient.post(`/forum/meldungen/${id}/erledigt`, { ergebnis });
}

export async function blendeBeitragAus(id: string, an: boolean): Promise<void> {
  await apiClient.post(`/forum/beitraege/${id}/ausblenden`, { an });
}

export async function aendereThema(
  id: string,
  felder: Partial<{ geschlossen: boolean; angeheftet: boolean; kategorieId: string }>,
): Promise<void> {
  await apiClient.patch(`/forum/themen/${id}`, felder);
}

export async function ladeSperren(): Promise<ForumSperre[]> {
  const { data } = await apiClient.get<ForumSperre[]>('/forum/sperren');
  return data;
}

export async function sperre(userId: string, tage: number, grund: string): Promise<void> {
  await apiClient.post('/forum/sperren', { userId, tage, grund });
}

export async function hebeSperreAuf(id: string): Promise<void> {
  await apiClient.delete(`/forum/sperren/${id}`);
}
